import { t, jt } from 'ttag'

import { BLACK, SG, SG90T } from '@h2/components/colors'
import connectSvg from '@h2/assets/svg/illustrations/upTheLadder/earlyLearnersCtaConnectToTeacher.svg'
import { EducatorsCodeIcon } from '@h2/components/icons/educatorsCode'
import { useIsUserOver13 } from '@h2/common/components/user/checkUser'

import { Cta } from './common/cta'

const brTag = <br key="brTag" />
const connectSpan = <span key="connect">{jt`to ${brTag} Your Navigator`}</span>
const Connect = ({ setOpenModal }) => {
  const isOver13 = useIsUserOver13()

  if (!isOver13) {
    return null
  }

  return (
    <Cta bgColor={SG90T} borderColor={SG} bgImage={connectSvg}>
      <Cta.Heading color={BLACK}>{jt`Connect ${connectSpan}`}</Cta.Heading>
      <Cta.Button
        icon={EducatorsCodeIcon}
        fontSize="20px"
        onClick={() => setOpenModal(true)}>
        {t`Get Started`}
      </Cta.Button>
    </Cta>
  )
}

export { Connect }
